import React from 'react';
import { Link } from 'react-router-dom';

const HelpCenterPage = () => (
  <div className="bg-[#0a0a0a] text-white min-h-screen px-8 py-16 sm:px-7 lg:px-8">
    <nav className="mb-16 text-center">
      <Link to="/" className="inline-flex items-center gap-2 no-underline">
        <span className="text-2xl">🧠</span>
        <span className="text-2xl font-bold text-[#e07a5f]">WhyDidItDie</span>
      </Link>
    </nav>

    <div className="max-w-3xl mx-auto text-center">
      <h1 className="text-4xl sm:text-5xl font-black mb-8 text-[#e07a5f]">Help Center</h1>
      <p className="text-lg sm:text-xl mb-8 text-white/80 leading-relaxed">
        Welcome to the WhyDidItDie Help Center. Whether you’re setting up for the first time or looking for advanced tips,
        we’re here to help you get answers — fast.
      </p>

      <div className="grid grid-cols-1 gap-6 mb-12">
        <div className="bg-white/5 p-6 rounded-xl">
          <h3 className="text-xl font-bold text-[#e07a5f] mb-2">🧩 Getting Started</h3>
          <p className="text-base text-white/80">
            Learn how to connect your ad accounts, set up your dashboard, and generate your first forensic report.
          </p>
        </div>

        <div className="bg-white/5 p-6 rounded-xl">
          <h3 className="text-xl font-bold text-[#e07a5f] mb-2">📊 Understanding Your Analysis</h3>
          <p className="text-base text-white/80">
            Need help interpreting failure points, timeline breakdowns, or AI-generated decisions? We've got you covered.
          </p>
        </div>

        <div className="bg-white/5 p-6 rounded-xl">
          <h3 className="text-xl font-bold text-[#e07a5f] mb-2">💳 Billing & Subscriptions</h3>
          <p className="text-base text-white/80">
            Get details on our pricing tiers, payment processing via Paystack, and how to manage your subscription.
          </p>
        </div>
      </div>

      <p className="text-base text-white/70 mb-8">
        We’re still building out our help docs — tutorials, video walkthroughs, and troubleshooting guides are coming soon.
        In the meantime, feel free to contact us at <a href="mailto:support@whydiditdie.com" className="text-[#e07a5f] underline hover:text-[#ff6b6b] transition-colors">support@whydiditdie.com</a>.
      </p>

      <a href="https://app.whydiditdie.com" className="text-[#e07a5f] text-lg no-underline hover:text-[#ff6b6b] transition-colors">← Back to Home</a>
    </div>
  </div>
);

export default HelpCenterPage;